import React from "react";
import { connect } from "react-redux";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { Button } from "../../../Common";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { client } from "../../../../shared/apiClient";
import ProjectDetailsSection from "../ProjectDetailsSection";
import PlaceholderImgSection from "../PlaceholderImgSection";
import ConflictsSection from "../ConflictsSection";
import InformationSection from "../InformationSection";
import { ISentInfoSheet, IInfoSheetsEnabled } from "../../../../shared/dto/IKioskDto";
import { iRootState } from "../../../../store";
import HeaderTemplate from "./HeaderTemplate";
import DisabledInfoSheet from "./DisabledInfoSheet";
import ConfirmDetailsSection from "../ConfirmDetailsSection";
import QuestionsAddEditSection from "./QuestionsAddEditSection";
import { IAuditionQuestion } from "../../../../interfaces/IAuditionQuestion";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../../Theme/custom-toast.css";
import QuestionsDisplaySection from "./QuestionsDisplaySection";
// @ts-ignore
import { IKioskSessionInfo } from "../../../../interfaces/IKioskSessionInfo";
import { isTodayAudition, isPastAudition } from "../../../../helpers";
import { ISessionTemplateInfoSheet } from "../../../../interfaces/ISessionTemplateInfoSheet";
import { IKioskSessionAuditionsDto } from "../../../../interfaces/IKioskSessionAuditionsDto";
import SendLoadingModal from "../../../Modals/SendLoadingModal";
import PlusBlue from "../../../../images/add_circle.svg";

const queryString = require("qs");

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t?: any;
  match: any;
  location: any;
}
const QuestionMaxCount = 6;

const defaultAuditionQuestions = [
  { displayOrder: 1, status: true } as IAuditionQuestion,
  { displayOrder: 2, status: true } as IAuditionQuestion,
  { displayOrder: 3, status: true } as IAuditionQuestion,
  { displayOrder: 4, status: true } as IAuditionQuestion,
  { displayOrder: 5, status: true } as IAuditionQuestion,
  { displayOrder: 6, status: true } as IAuditionQuestion,
] as IAuditionQuestion[];

// TODO: review unnecesary complexity of temp question when they could instead be generated on the fly in view component...
class TemplateInfoSheet extends React.Component<IProps, {}> {
  state = {
    isReadOnly: true,
    showAddEditQuestions: false,
    tmpAuditionQuestions: defaultAuditionQuestions,
    showSendModal: false,
    scheduleId: "",
    isLoading: false,
    enabled: false
  };

  async componentDidMount() {
    try {
      const { match } = this.props;
      if (!match || !match.params || !match.params.id)
        this.props.history.push("/500");

      // TODO: loading state

      const scheduleId = match.params.id;
      this.setState({ scheduleId });

      await this.props.getSessionTemplateInfoSheet(scheduleId);

      await this.props.getKioskSessionInfo(scheduleId);

      await this.props.getAuditionQuestions(scheduleId);

      if (this.props.auditionQuestions.length > 0) {
        this.setState({ tmpAuditionQuestions: this.props.auditionQuestions });
      }

      await this.props.getSessionAuditions(scheduleId);
    } catch (error) {
      this.props.history.push("/500");
    }
  }

  componentWillUnmount() {
    this.props.setKioskSessionAuditions(null);
  }

  onShowAddEditQuestions = () => {
    this.setState({ showAddEditQuestions: !this.state.showAddEditQuestions });
    window.scrollTo(0, document.body.scrollHeight);
  };

  onAddSingleQuestion = () => {
    let questions = [...this.state.tmpAuditionQuestions];

    // If user deleted existing, but add one more questions in the same Edit/Cancel/Save session.
    if (questions.some((x) => x.status === false && x.auditionQuestionId)) {
      let question = questions.find((x) => x.status === false);
      const updatedQuestions = questions.map((q: IAuditionQuestion) => {
        if (q.auditionQuestionId === question.auditionQuestionId)
          q.status = true;
        return q;
      });
      this.setState({ tmpAuditionQuestions: updatedQuestions });
      return;
    }

    // something wrong...
    if (questions.length >= QuestionMaxCount) return;

    var qToAdd = defaultAuditionQuestions.filter(
      (i) => !questions.some((x) => i.displayOrder === x.displayOrder)
    )[0];

    questions.push(qToAdd);

    this.setState({ tmpAuditionQuestions: questions });
  };

  onRemoveQuestion = (question: IAuditionQuestion) => {
    let questions = [...this.state.tmpAuditionQuestions];

    let updatedQuestions = [] as IAuditionQuestion[];
    if (question.auditionQuestionId)
      updatedQuestions = questions.map((q: IAuditionQuestion) => {
        if (q.auditionQuestionId === question.auditionQuestionId)
          q.status = false;
        return q;
      });
    else
      updatedQuestions = questions.filter(
        (x) => x.displayOrder !== question.displayOrder
      );

    this.setState({ tmpAuditionQuestions: updatedQuestions });
  };

  // TODO: orderQuestion By display order

  onCancel = () => {
    this.setState({
      showAddEditQuestions: false,
      tmpAuditionQuestions:
        this.props.auditionQuestions.length > 0
          ? this.props.auditionQuestions
          : defaultAuditionQuestions,
    });
  };

  onSaveQuestions = async () => {
    this.setState({ showAddEditQuestions: false });

    const { tmpAuditionQuestions } = this.state;

    let message = this.props.t("Custom Questions Added!");
    if (tmpAuditionQuestions.some((x) => x.auditionQuestionId))
      message = this.props.t("Custom Questions Updated!");

    toast.success(message, {
      position: "top-right",
    });

    const questions = tmpAuditionQuestions.filter(
      (x) => x.question && x.question.length > 0
    );

    let toUpdate = questions.filter((x) => x.auditionQuestionId);
    let toCreate = questions.filter((x) => !x.auditionQuestionId);
    if (toCreate.length > 0) {
      await this.props.addAuditionQuestions(toCreate);
      await this.updateTempAuditionQuestions();
    }
    if (toUpdate.length > 0) {
      await this.props.updateAuditionQuestions(toUpdate);
      await this.updateTempAuditionQuestions();
    }
  };

  updateTempAuditionQuestions = async () => {
    await this.props.getAuditionQuestions(this.state.scheduleId);
    this.setState({ tmpAuditionQuestions: this.props.auditionQuestions });
  };

  // onSendToTalent = () => {
  //   this.setState({ showSendModal: true });
  // };

  // onAttachAndSave = () => {
  //   const qsArgs = decodeURI(window.location.search).split("?")[1];
  //   const result = queryString.parse(qsArgs);
  //   if (result.back) {
  //     // window.location.href = "projects-vcr.asp?display=active";
  //     let bdId = this.props.sessionInfo.breakdownId;
  //     if (!bdId) {
  //       bdId = this.props.sessionAuditions.bdId;
  //     }

  //     window.location.href = `/castingworkbook/directors/projects-vcr.asp?display=active&sbd=${bdId}#${bdId}`;
  //   } else {
  //     this.props.history.push({
  //       pathname: `/`,
  //       state: {
  //         showSaveSheet: true,
  //       },
  //     });
  //   }
  // };

  // onSendInfoSheetConfirmModal = async () => {
  //   await this.props.sendInfoSheet(this.state.scheduleId);
  //   this.props.history.push({
  //     pathname: `/`,
  //     state: {
  //       showSentToast: true,
  //     },
  //   });
  // };

  isAspRedirect = () => {
    const qsArgs = decodeURI(window.location.search).split("?")[1];
    const result = queryString.parse(qsArgs);
    return result.back;
  };

  onSaveAndClose = async () => {
    if (this.isAspRedirect()) {
      this.redirectAsp("save");
    } else {
      this.redirectHome("saved");
    }
  };

  onSaveAndSend = async () => {
    const { t, sendInfoSheet, setShowFailedEmailModal } = this.props;
    this.setState({ isLoading: true });
    const success = await sendInfoSheet(this.state.scheduleId);
    if (success) {
      toast.success(t("Info Sheet sent successfully"), {
        position: "top-right"
      });
    } else if (success === false) {
      toast.error((
        <span>
          {t("Some attendees did not receive the Info Sheet.")}
          &nbsp;
          <StyledButton
            onClick={() => setShowFailedEmailModal(true)}
          >
            {t("view details")}
          </StyledButton>
        </span>
      ), {
        position: "top-right",
        autoClose: false
      });
    }
    this.setState({ isLoading: false });
    if (this.isAspRedirect()) {
      setTimeout(() => {
        this.redirectAsp("sent");
      }, 1000);
    } else {
      this.redirectHome("");
    }
  };

  redirectHome = (status: string) => {
    this.props.history.push({
      pathname: `/`,
      state: {
        infoSheetToast: status,
      },
    });
  };

  redirectAsp = (s: string) => {
    const bdType = this.props.sessionAuditions.bdType;
    let bdId = this.props.sessionInfo.breakdownId;
    if (!bdId) {
      bdId = this.props.sessionAuditions.bdId;
    }

    let redirectUrl = `/castingworkbook/directors`;
    redirectUrl = bdType === 2 ? `${redirectUrl}/commercial` : redirectUrl;
    redirectUrl = `${redirectUrl}/projects-vcr.asp?`;
    redirectUrl = (s === "save" || s === "sent")
      ? `${redirectUrl}info=${s}&`
      : redirectUrl;
    redirectUrl = `${redirectUrl}display=active&sbd=${bdId}#${bdId}`;

    window.location.href = redirectUrl;
  };

  onCancelModal = () => {
    this.setState({ showSendModal: false });
  };

  onChangeQuestion = (e: any, question: IAuditionQuestion) => {
    if (!e || !question) return;
    question.question = e.target.value;
    let questions = this.state.tmpAuditionQuestions.map(
      (q: IAuditionQuestion) => {
        if (
          (q.auditionQuestionId &&
            q.auditionQuestionId === question.auditionQuestionId) ||
          q.displayOrder === question.displayOrder
        )
          return question;
        return q;
      }
    );
    this.setState({ tmpAuditionQuestions: questions });
  };

  isTvFilm = () => {
    const { sessionAuditions } = this.props;
    if (!sessionAuditions || !sessionAuditions.bdType) return true;
    const bdtype = sessionAuditions.bdType;
    return bdtype === 1 || bdtype === 0 || bdtype === 4;
  };

  render() {
    const {
      t,
      sessionTemplateInfoSheet,
      sessionAuditions,
      sentInfoSheets,
      sessionInfo,
    } = this.props;
    const {
      tmpAuditionQuestions,
      showAddEditQuestions,
      isReadOnly,
    } = this.state;

    const breadCrumbList = [
      {
        label: t("Scheduling"),
        to: `${client.api.paths.domain}/castingworkbook/directors/schedulelist.asp`,
      },
      { label: t("Casting Kiosk"), to: "/", relative: true },
      {
        label: `
          ${sessionInfo && sessionInfo.projectName
            ? sessionInfo.projectName
            : ""
          } ${sessionInfo && sessionInfo.scheduleName
            ? sessionInfo.scheduleName
            : ""
          }
        `,
        to: `/castingworkbook/kiosk/sessionAuditions/${this.state.scheduleId}`,
      },
      { label: t("Info sheet") },
    ];

    const hasSavedAuditionQuestions = tmpAuditionQuestions.some(
      (x) => x.auditionQuestionId
    );

    let pastAudition = false;
    if (
      sessionAuditions &&
      sessionAuditions.auditionsDetails &&
      sessionAuditions.auditionsDetails.length > 0
    ) {
      pastAudition = isPastAudition(
        sessionAuditions.auditionsDetails[
          sessionAuditions.auditionsDetails.length - 1
        ].auditionTime,
        sessionAuditions.auditionDate
      ) && !isTodayAudition(sessionAuditions.auditionDate);
    }

    return (
      <>
        {/* {this.state.showSendModal && (
          <Modal
            title="test"
            message="test message"
            show={this.state.showSendModal}
            onCancel={this.onCancelModal}
            sessionTemplateInfoSheet={sessionTemplateInfoSheet}
            onConfirm={this.onSendInfoSheetConfirmModal}
            sentCount={sentCount ? sentCount : 0}
          />
        )} */}
        {/* <ToastContainer
          hideProgressBar={true}
          toastClassName="toaster--success"
          bodyClassName="toaster-body toaster__icon--success"
        /> */}
        <SendLoadingModal show={this.state.isLoading} />
        <Wrapper>
          <HeaderTemplate
            sessionTemplateInfoSheet={sessionTemplateInfoSheet}
            breadCrumbList={breadCrumbList}
            enabled={sessionInfo.infoSheetsEnabled}
            onEnabledChange={e => this.props.setInfoSheetsEnabled({
              scheduleId: sessionInfo.scheduleId,
              enabled: e.target.checked
            })}
            //onShowAddEditQuestions={this.onShowAddEditQuestions}
            onSaveAndClose={this.onSaveAndClose}
            onSaveAndSend={this.onSaveAndSend}
            hasSentInfoSheet={sentInfoSheets && sentInfoSheets.length > 0}
            pastAudition={pastAudition}
          ></HeaderTemplate>
          {sessionInfo.infoSheetsEnabled ? (
            <ContentBox>
              <ContentHeader className="opaque">
                <ContentTitle>{t("AUDITION INFO SHEET TEMPLATE")}</ContentTitle>
              </ContentHeader>
              <div className="row">
                <div className="col-6 shift-left-15 opaque">
                  <div className="col-12">
                    <ProjectDetailsSection
                      sessionTemplateInfoSheet={sessionTemplateInfoSheet}
                    />
                  </div>
                  <div className="col-12">
                    <ConflictsSection
                      sessionTemplateInfoSheet={sessionTemplateInfoSheet}
                      isReadOnly={isReadOnly}
                      isTvFilm={this.isTvFilm()}
                    />
                  </div>
                </div>
                <div className="col-6 opaque">
                  <PlaceholderImgSection isReadOnly={isReadOnly} />
                </div>
                <div className="col-12 opaque">
                  <InformationSection
                    sessionTemplateInfoSheet={sessionTemplateInfoSheet}
                    isReadOnly={isReadOnly}
                    isTvFilm={this.isTvFilm()}
                  />
                </div>
                <div className="col-12">
                  {!hasSavedAuditionQuestions && (
                    <Button
                      disabled={pastAudition || !sessionTemplateInfoSheet}
                      startIcon={<img alt="plus" src={PlusBlue} />}
                      variant="secondary"
                      onClick={this.onShowAddEditQuestions}
                    >
                      {t("Add custom questions")}
                    </Button>
                  )}
                  {hasSavedAuditionQuestions && !showAddEditQuestions && (
                    <QuestionsDisplaySection
                      auditionQuestions={tmpAuditionQuestions}
                      showAddEditQuestions={this.state.showAddEditQuestions}
                      onShowAddEditQuestions={this.onShowAddEditQuestions}
                      pastAudition={pastAudition}
                    />
                  )}
                  {showAddEditQuestions && (
                    <QuestionsAddEditSection
                      onShowAddEditQuestions={this.onShowAddEditQuestions}
                      showAddEditQuestions={this.state.showAddEditQuestions}
                      auditionQuestions={tmpAuditionQuestions}
                      onRemoveQuestion={this.onRemoveQuestion}
                      onCancel={this.onCancel}
                      onSaveQuestions={this.onSaveQuestions}
                      onChangeQuestion={this.onChangeQuestion}
                      onAddSingleQuestion={this.onAddSingleQuestion}
                    />
                  )}
                </div>
                <div className="col-12 opaque">
                  <ConfirmDetailsSection isReadOnly={isReadOnly} />
                </div>
              </div>
            </ContentBox>
          ) : (
            <DisabledInfoSheet
              onEnableClick={() => this.props.setInfoSheetsEnabled({
                scheduleId: sessionInfo.scheduleId,
                enabled: true
              })}
            />
          )}
        </Wrapper>
      </>
    );
  }
}

interface StateProps {
  sessionTemplateInfoSheet: ISessionTemplateInfoSheet;
  auditionQuestions: IAuditionQuestion[];
  sessionAuditions: IKioskSessionAuditionsDto;
  sentInfoSheets: ISentInfoSheet[];
  sessionInfo: IKioskSessionInfo;
}

function mapStateToProps(state: iRootState): StateProps {
  return {
    sessionTemplateInfoSheet: state.kiosk.sessionTemplateInfoSheet,
    auditionQuestions: state.kiosk.auditionQuestions,
    sessionAuditions: state.kiosk.sessionAuditions,
    sentInfoSheets: state.kiosk.sentInfoSheets,
    sessionInfo: state.kiosk.sessionInfo,
  };
}

interface DispatchProps {
  getSessionTemplateInfoSheet: (id: string) => void;
  getAuditionQuestions: (id: string) => void;
  addAuditionQuestions: (questions: IAuditionQuestion[]) => void;
  updateAuditionQuestions: (questions: IAuditionQuestion[]) => void;
  getSessionAuditions: (id: string) => void;
  getSentAuditionInfoSheet: (ids: number[]) => ISentInfoSheet[];
  sendInfoSheet: (id: string) => boolean;
  setKioskSessionAuditions: (
    sessionAuditions: IKioskSessionAuditionsDto
  ) => void;
  getKioskSessionInfo: (id: any) => void;
  setShowFailedEmailModal: (show: boolean) => any;
  setInfoSheetsEnabled: (payload: IInfoSheetsEnabled) => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    getSessionTemplateInfoSheet: dispatch.kiosk.getSessionTemplateInfoSheet,
    getAuditionQuestions: dispatch.kiosk.getAuditionQuestions,
    addAuditionQuestions: dispatch.kiosk.addAuditionQuestions,
    updateAuditionQuestions: dispatch.kiosk.updateAuditionQuestions,
    getSessionAuditions: dispatch.kiosk.getSessionAuditions,
    getSentAuditionInfoSheet: dispatch.kiosk.getSentAuditionInfoSheet,
    sendInfoSheet: dispatch.kiosk.sendInfoSheet,
    setKioskSessionAuditions: dispatch.kiosk.setKioskSessionAuditions,
    getKioskSessionInfo: dispatch.kiosk.getKioskSessionInfo,
    setShowFailedEmailModal: dispatch.kiosk.setShowFailedEmailModal,
    setInfoSheetsEnabled: dispatch.kiosk.setInfoSheetsEnabled
  };
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: ${(p) => p.theme.kiosk.backgroundColor};

  .cwb-table-wrapper {
    max-width: 1040px;
    border: 1px solid #e7e7f0 !important;
    box-shadow: 0 2px 4px 0 #e0e0e0 !important;
    border-radius: 4px;
  }
`;

const ContentBox = styled.div`
  background: white;
  padding: 24px;
  width: 100%;
  min-height: 70vh;
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  margin: 40px auto;
  overflow-x: hidden;
  overflow-y: hidden;
  box-shadow: 0 2px 4px #E0E0E0;

  & .opaque { opacity: 0.5; }

  & input.form-control-plaintext:focus { outline: none; }

  & input.form-control, textarea.form-control {
    background-color: #FAFAFA;
    border: 1px solid ${p => p.theme.palette.misc.disabled};
  }
`;

const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
  margin-right: 2px;
`;

const ContentTitle = styled.div`
  color: ${(p) => p.theme.color.grey};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
`;

const StyledButton = styled.button`
  color: #0F9BF0;
  padding: 0;
  background-color: #FFF;
  border: none;
  text-decoration: underline;
`;

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TemplateInfoSheet))
);
